import {FormControl, FormGroup} from '@angular/forms';
import {SelectMetersForAgentFormGroup} from '../select-meters-for-agent/select-meters-for-agent.model';

export const AGENT_CONSUMPTION_TYPES = [
    'INDIVIDUALCONSUMPTION',
    'SUMMEDCONSUMPTION',
    'DIFFERENCECONSUMPTION',
] as const;

export type ConsumptionToMonitor = (typeof AGENT_CONSUMPTION_TYPES)[number];

export type AgentMonitoringFormGroup = FormGroup<{
    consumptionToMonitor: FormControl<ConsumptionToMonitor>;
    selectMetersForAgentFormGroup: SelectMetersForAgentFormGroup;
}>;

export type AgentConsumptionToMonitorEntry = {
    type: ConsumptionToMonitor;
    translationKey: string;
    descriptionKey: string;
};

export const consumptionToMonitorEntries: AgentConsumptionToMonitorEntry[] = [
    {
        type: 'INDIVIDUALCONSUMPTION',
        translationKey: 'monitoring_consumption_select_individual_meter',
        descriptionKey: 'consumption-agents_create_monitoring_individual_description',
    },
    {
        type: 'SUMMEDCONSUMPTION',
        translationKey: 'monitoring_summed_up_consumption_from_selected_meters',
        descriptionKey: 'consumption-agents_create_monitoring_summed_description',
    },
    {
        type: 'DIFFERENCECONSUMPTION',
        translationKey: 'monitoring_difference_in_consumption_between_groups',
        descriptionKey: 'consumption-agents_create_monitoring_difference_description',
    },
];
